import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetActionCreateEditProvider } from './context/budget-action-create-edit-context';
import { BudgetActionCreateEditComponent } from './budget-action-create-edit-component';

export function BudgetActionCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetActionCreateEditProvider>
                <BudgetActionCreateEditComponent />
            </BudgetActionCreateEditProvider>
        </BaseLayoutFactory>
    );
}
